<div class="mybets-scoreboard_players">
    <div class="cell">
        <div class="mybets-scoreboard_players-name">{{ vm().player1 }}</div>
        <ng-content select="[player1_indicators]"></ng-content>
        @if (vm().player1AwayIndicator) {
            <span class="mybets-scoreboard_players-away-indicator" [msAutomation]="'mybets-away-indicator'">{{
                sitecore.globalMessages.AwayIndicator
            }}</span>
        }
    </div>
    <div class="cell">
        <div class="mybets-scoreboard_players-name">{{ vm().player2 }}</div>
        <ng-content select="[player2_indicators]"></ng-content>
        @if (vm().player2AwayIndicator) {
            <span class="mybets-scoreboard_players-away-indicator" [msAutomation]="'mybets-away-indicator'">{{
                sitecore.globalMessages.AwayIndicator
            }}</span>
        }
    </div>
    <div class="cell"><ms-my-bets-scoreboard-time [vm]="vm().getEventTimeViewModel()"></ms-my-bets-scoreboard-time></div>
</div>
